/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {submitClabeEntry} from '../api'

export const useMutationSubmitClabeEntry = createReactQueryMutationHook('submitClabeEntry', submitClabeEntry)
